import { render } from "./SummaryPageView.vue?vue&type=template&id=462bff4b&ts=true"
import script from "./SummaryPageView.vue?vue&type=script&lang=ts"
export * from "./SummaryPageView.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__